//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import checkBox from '@/components/card/checkBox';
import { removeReport } from '@/utils/report';
import { upload_img, getObjectURL } from '@/utils/tools';
import { report_api } from '@/api/api/user';

export default {
  data() {
    return {
      removeReport,
      reason: [],
      img_list: {},
      img_id: 0,
      reason_select: -1000,
      report_desc: '',
    };
  },
  components: { checkBox },
  computed: {
    disableMark() {
      return this.reason_select === -1000 || !this.report_desc;
    },
  },
  async mounted() {
    const { data } = await this.$nuxt.$axios.get(report_api.report_info);
    if (data.code === 'OK') {
      this.reason = data.data || [];
    }
  },
  methods: {
    remove_img(item) {
      delete this.img_list[item.id];
      this.$forceUpdate();
    },
    async report() {
      if (!this.report_desc) {
        this.$message({
          message: '请输入举报原因',
          type: 'error',
        });
        return false;
      }
      if (!this.reason_select === -1000) {
        this.$message({
          message: '请选择举报原因',
          type: 'error',
        });
        return false;
      }
      const img_list = this.img_list;
      const img_result = [];
      for (const key in img_list) {
        if (img_list[key].result_url) img_result.push(img_list[key].result_url);
      }
      const params = {
        res_id: Number(this.res_id),
        res_type: this.res_type,
        report_msg: this.reason_select,
        report_desc: this.report_desc,
        img_list: img_result,
      };
      try {
        await this.$nuxt.$axios.post(report_api.resource_report, params);
        removeReport('report');
        this.$message({
          message: '信息已提交，举报结果会通过邮件 / 短信告知',
          type: 'success',
        });
      } catch (e) {
        console.log('err', e);
        this.$message({
          message: '举报失败,请重试',
          type: 'error',
        });
      }

      return true;
    },
    choose_reason(item) {
      this.reason_select = item.report_message_id;
    },
    async img_upload(event) {
      const current_id = this.img_id;
      this.img_id++;
      const file = event.target.files[0];
      this.$refs.upload_input.value = '';
      if (file.size > 2000 * 1000) {
        this.$nuxt.$message({
          message: '最大上传2M',
          type: 'error',
        });
        return false;
      }
      this.img_list[current_id] = {
        origin_url: getObjectURL(file),
        id: current_id,
      };
      this.$forceUpdate();
      try {
        const res = await upload_img(file);
        if (this.img_list[current_id]) this.img_list[current_id].result_url = res.url;
      } catch (e) {
        delete this.img_list[current_id];
      }
      this.$forceUpdate();
      return true;
    },
  },
};
